import { styled } from '@mui/material/styles';
import { DS_breakpoints as coreBreakpoints } from 'mui/base/theme/DS_Tokens/core';
import { layoutHorizontalGapStyles } from 'mui/components/sharedStyles/layoutStyles';

export const StyledContainer = styled('div')(
  ({ theme }) => `
     ${layoutHorizontalGapStyles({ theme })};
   
   ${theme.breakpoints.up('lg')} {
        padding-left:  ${theme.DS_spacing(['lgx'])};
        margin: 0 ${theme.DS_spacing(['xxxl'])};
     }
     ${theme.breakpoints.up('xl')} { 
     padding-left:  ${theme.DS_spacing(['xlx'])};
      max-width: ${coreBreakpoints['xl']}em;  
      margin: 0 auto;
     }
  
  `,
);

export const Date = styled('div')(
  ({ theme }) => `
  &:first-letter {
    text-transform: uppercase;
  }

  &.noDatesAvailable {
    margin-top: ${theme.DS_spacing(['md'])};
  }
`,
);
